import { isNode, worker } from "../mocks/browser";

export const isDev =
  window.location.host.startsWith("dev.") || process.env.VITE_TARGET_ENV === "DEV";
export const isUAT =
  window.location.host.startsWith("uat.") ||
  window.location.host.startsWith("butter.") || // butter should be tested aginast UAT - remove this when butter goes to PROD
  window.location.host.startsWith("uat-") || // uat- is for if we need to point a frontend preview branch to UAT for backend reasons
  import.meta.env.VITE_TARGET_ENV === "UAT";
export const isProd =
  ["bebop.xyz", "beta.bebop.xyz"].includes(window.location.host) ||
  process.env.VITE_TARGET_ENV === "PROD";
export const isLocal =
  window.location.host.includes("localhost") ||
  window.location.host.includes("127.0.0.1") ||
  window.location.host.startsWith("192.168.1");
export const isFeatureBranch = window.location.host.includes(".bebop-ui.pages.dev");
export type Env = "UAT" | "DEV" | "PROD";
export type ApiEnv = "MOCK" | "UAT" | "PROD";

let workerStarted = false;

export const HostEnvironments = {
  PROD: "bebop.xyz",
  BETA: "beta.bebop.xyz",
  DEV: "dev.bebop.xyz",
  LOCAL: "localhost:3000",
};

export const API_ENV_URL_MAP: Record<ApiEnv, string> = {
  MOCK: "https://api-uat.bebop.xyz",
  UAT: "https://api-uat.bebop.xyz",
  PROD: "https://api.bebop.xyz",
};

export const getApiEnv = (): ApiEnv => {
  if (isLocal && !isNode() && import.meta.env.VITE_TARGET_ENV === "MOCK") {
    if (!workerStarted) {
      void worker?.start();
      workerStarted = true;
    }
    return "MOCK";
  }
  if (isDev || isUAT) {
    return "UAT";
  }
  return "PROD"; // local and prod
};

const apiEnv = getApiEnv();
export const API_BASE_URL: string = API_ENV_URL_MAP[apiEnv];
export const API_VERSION = "v2";
export const JAM_VERSION = "v1";
export const TOKENS_VERSION = "v1";
export const WAITLIST_VERSION = `v1`;
